import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'actual-change-window';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Actual Change Window',
};

const actualChangeWindow = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { actualChangeWindow };
